import { render, staticRenderFns } from "./AlertasVigencia.vue?vue&type=template&id=ad4e55d6&"
import script from "./AlertasVigencia.vue?vue&type=script&lang=js&"
export * from "./AlertasVigencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports